module.exports = __webpack_public_path__ + "static/img/case_3.f842a05d.jpg";